import type { Metadata } from "next";
import { DM_Sans, Playfair_Display } from "next/font/google";
import { ClerkProvider } from "@clerk/nextjs";
import PageTransition from "@/components/ui/PageTransition";
import { clerkConfig } from "@/lib/clerk-config";
import "./globals.css";

const dmSans = DM_Sans({
  variable: "--font-sans",
  subsets: ["latin"],
  weight: ["400", "500"],
});

const playfairDisplay = Playfair_Display({
  variable: "--font-serif",
  subsets: ["latin"],
  weight: ["400", "700"],
});

export const metadata: Metadata = {
  title: "Vela — Business Workstation",
  description: "One platform for your entire business. Pay only for what you use.",
};

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  // Check if publishable key is available
  if (!process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY) {
    console.warn("Clerk Publishable Key is missing from environment variables.");
  }

  return (
    <ClerkProvider {...clerkConfig}>
      <html
        lang="en"
        className={`${dmSans.variable} ${playfairDisplay.variable} h-full antialiased`}
      >
        <body className="min-h-full flex flex-col">
          <PageTransition />
          {children}
        </body>
      </html>
    </ClerkProvider>
  );
}
